import { useState, useEffect } from "react";
import apiClient from "../../ApiClient";
import { useGlobalState } from "../../../context/GlobalStateContext";

function useAuth() {
  const { state, dispatch } = useGlobalState();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isConsentGiven, setIsConsentGiven] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);
  const [userRoles, setRoles] = useState<any[]>([]);

  useEffect(() => {
    const validateSession = async () => {
      if (!!state.tepnguser?.user) {
        setIsConsentGiven(state.tepnguser?.user?.userConsent?.consentGiven);
        setIsAuthenticated(true);
        setRoles(state.tepnguser?.roles);
        setLoading(false);

      } else {
        try {
          const res = await apiClient.post("Authentication/UserLogin", {});
          const data = res.data.data;
          const userRoles = data?.roles;

          dispatch({ type: "SET_TEPNGUSER", payload: res.data.data });
          setIsConsentGiven(res.data.data?.user?.userConsent?.consentGiven);
          setIsAuthenticated(true);
          setRoles(userRoles);

        } catch (error) {
          setIsAuthenticated(false);
        } finally {
          setLoading(false);
        }
      }
    };

    validateSession();
  }, [state.tepnguser, dispatch]);

  return { isAuthenticated, isConsentGiven, userRoles, loading };
}

export default useAuth;
